import { SurveyService } from './../survey.service';
import { Component, OnInit, OnChanges } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormControl, NgForm } from '@angular/forms';
import { FormGroup } from '@angular/forms';



@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {

  id: any;
  question: any;
  survey_name: any;
  answer_options: any;
  surveyForm: FormGroup;
  current_question: any = 0;
  new_array: any = [];
  question_length: any = 0;
  survey_completed = false;
  survey_ended = false;
  user_id: any;
  survey_object: any = {};
  survey_already_filled: any = false;
  array_checkbox: any = [];
  check: boolean = false;
  required: boolean = false;
  radio_check: boolean = false;
  checkbox_check: boolean = false;
  checkbox_limit: any = 0;
  checbox_count: any = 0;
  check_limit: boolean = false;
  checklimit_error: any;
  question_ended: boolean = false;
  limit_display: boolean = false;
  is_profile: any;
  constructor(private router: ActivatedRoute, private Surveyservice: SurveyService, private route: Router) {
    router.params.subscribe(params => {
      this.id = params['id'];
    });
    this.user_id = localStorage.getItem("user_id");
    if (this.user_id) {
      this.Surveyservice.CheckSurvey(this.id, this.user_id).subscribe(response => {
        let check = response; //response.json();
        if (check.status == true) {
          this.survey_completed = false;
          this.survey_ended = true;
          this.survey_already_filled = true;
        }
        else {
          this.Surveyservice.SurveyQuestions(this.id, this.user_id).subscribe(response => {
            let data = response; //response.json();
            console.log(data);
            this.is_profile = data.isProfile;
            if (data.status == true) {
              this.question = data.survey_data;
              this.question_length = data.survey_data.length;
              this.survey_name = data.survey_name;
              this.answer_options = data.survey_data.options;
              if(this.is_profile === 1){
                this.auto_populate();
              }
            }
            else {
              route.navigate(['**']);
            }
          })
        }
      });
    }
    else {
      route.navigate(['login']);
    }
  }

  ngOnInit() {}
  

  //For radio questions
  onAnswer(answer: any, question_id: any, question_length: any, userAnswer: any, type: any, r_status, radio) {
    if ((r_status == "True" && radio.checked) || (r_status == "False" && radio.checked)) {
      this.radio_check = true;
      this.survey_object = { "question_id": question_id, "answer": answer, "userAnswer": userAnswer, "type": type };
      console.log(this.survey_object);
    }
  }

  //For checkbox questions
  onAnswers(answer: any, question_id: any, question_length: any, userAnswer: any, type: any, checkbox: any, r_status, limit: any) {
    this.check = true;
    this.question_length = question_length;
    if ((r_status == "True" && checkbox.checked) || (r_status == "False" && checkbox.checked)) {
      this.checkbox_check = true;
      console.log(this.checkbox_check);
      this.survey_object = { "question_id": question_id, "answer": answer, "userAnswer": userAnswer, "type": type };
      this.array_checkbox.push(this.survey_object);
      this.checbox_count++;
      if (limit == this.checbox_count || limit == '0' || this.checbox_count > limit) {
        this.check_limit = true
      }
    }
    else {
      for (let i = 0; i < this.array_checkbox.length; i++) {
        if (this.array_checkbox[i].answer == answer) {
          this.array_checkbox.splice(i, 1);
          this.checbox_count--;
        }
        if ((this.array_checkbox.length === 0 && r_status == "True") || (this.array_checkbox.length === 0 && r_status == "False")) {
          this.checkbox_check = false;
          this.check = false;
        }
        if (this.checbox_count < limit) {
          this.check_limit = false;
        }
      }
    }
  }

  
  next(answer: any, question_id: any, question_length: any, userAnswer: any, type: any, r_status: any, limit: any) {
    this.question_length = question_length;
    this.selected_checkbox();
    console.log(this.checkbox_check);
    // console.log(limit);
    if (this.check_limit == false && limit !== 0 && type == 'Checkbox') {
      this.checklimit_error = "Please select atleast " + limit;             // Checking Limit for checkbox
      console.log("error");
    }
    else if ((this.radio_check == false && type == 'Radio' && r_status == "True") || (this.checkbox_check == false && type == "Checkbox" && r_status == "True") || (r_status == "True" && userAnswer == "" && (type == 'Shortanswer' || type == 'Longanswer'))) {
      this.required = true;
      console.log("required2")                                               // Checking required or not 
    }
    else {
      this.question_length = question_length;
      if (type == 'Shortanswer' || type == "Longanswer") {
        this.survey_object = { "question_id": question_id, "answer": answer, "userAnswer": userAnswer, "type": type };     // creating object when type is short/long      
      }
      if ((r_status == 'False' && this.radio_check == false && type == "Radio") || (r_status == 'False' && this.checkbox_check == false && type == "Checkbox")) {
        this.survey_object = { "question_id": question_id, "answer": 0, "userAnswer": userAnswer, "type": type };
        console.log("condition2")
      }
      if (type !== 'Checkbox' && (r_status == 'True' || r_status == 'False')) {
        this.new_array.push(this.survey_object);
        console.log(this.new_array);
        this.required = false;
        this.radio_check = false;
        this.current_question++;          // Object pushed to array if type is radio,long,short 
        this.survey_object = {};
        userAnswer = "";
        console.log("hi");
      }
      if (type == 'Checkbox'  && r_status == 'False' && this.checkbox_check == false) {
        this.new_array.push(this.survey_object);
        console.log(this.new_array);
        this.required = false;        // Object pushed to array if type is checkbox and not checked 
        this.current_question++;
        this.survey_object = {};
      }
      if (this.question_ended == true) {
        this.current_question++;
      }
      if (this.current_question == this.question_length) {
        if(this.is_profile === 0)
        {
          this.survey_ended = true;
          let user_id: any = localStorage.getItem("user_id");
          let object = { "survey_id": this.id, "array_data": this.new_array, "user_id": user_id };
          this.Surveyservice.SurveySubmit(JSON.stringify(object)).subscribe(response => {
            console.log(response);
            let data = response; //response.json();
            if (data.status == true) {
              this.survey_completed = true;
            }
            setTimeout(() => {
              this.route.navigate([''])
            }, 5000);
          });
        }else{
          this.Surveyservice.CheckPerviousSurvey(this.id, this.user_id).subscribe(response => {
            let checkdata = response; //response.json();
            if (checkdata.status == true) {
              
              this.Surveyservice.DeletePerviousSurvey(this.id,this.user_id).subscribe(response => {
                let checking = response;
                if (checking.status == true) {
                  this.survey_ended = true;
                  let user_id: any = localStorage.getItem("user_id");
                  let object = { "survey_id": this.id, "array_data": this.new_array, "user_id": user_id };
                  this.Surveyservice.SurveySubmit(JSON.stringify(object)).subscribe(response => {
                    console.log(response);
                    let data = response; //response.json();
                    if (data.status == true) {
                      this.survey_completed = true;
                    }
                    setTimeout(() => {
                      this.route.navigate([''])
                    }, 5000);
                  });
                }
              })
            }else
            {
              this.survey_ended = true;
          let user_id: any = localStorage.getItem("user_id");
          let object = { "survey_id": this.id, "array_data": this.new_array, "user_id": user_id };
          this.Surveyservice.SurveySubmit(JSON.stringify(object)).subscribe(response => {
            console.log(response);
            let data = response; //response.json();
            if (data.status == true) {
              this.survey_completed = true;
            }
            setTimeout(() => {
              this.route.navigate([''])
            }, 5000);
          });
            }
          });
        }
      }
     
      
      

    }
    if(this.is_profile === 1){
      if(this.current_question == this.question_length){
      }else{
        this.auto_populate();
      } 
    }
    this.checkbox_check = false;
    // console.log(this.checkbox_check);
  }

  selected_checkbox() {
    if (this.check == true && this.check_limit == true) {
      this.array_checkbox.forEach(element => {
        this.new_array.push(element);
      });
      console.log("selected_checkbox function");
      console.log(this.new_array);
      if (this.current_question + 1 == this.question_length) {
        this.question_ended = true;
        this.check = false;
        this.required = false;
        // this.check_limit = false
        this.survey_object = {};
        this.array_checkbox.length = 0;
        this.checklimit_error = "";
        this.checbox_count = 0;

      } else {
        this.current_question++;
        this.check = false;
        this.required = false;
        this.check_limit = false
        this.survey_object = {};
        this.array_checkbox.length = 0;
        this.checklimit_error = "";
        this.checbox_count = 0;
        this.limit_display = false;

      }
    }
  }
  auto_populate() {
    console.log("i am, called");
    if (this.is_profile === 1 && JSON.stringify(this.survey_object) === '{}' && this.question[this.current_question].type == 'Radio') {
      this.question[this.current_question].options.forEach(element => {
        if (element.selected == 1) {
          this.radio_check = true;
          this.survey_object = { "question_id": element.SurveyQuestionID, "answer": element.SurveyAnswerID, "userAnswer": "None", "type": this.question[this.current_question].type };
        }
      });
    }
    if (this.is_profile === 1 && JSON.stringify(this.survey_object) === '{}' && this.question[this.current_question].type == 'Checkbox') {
      this.checbox_count = 0;
      this.question[this.current_question].options.forEach(element => {
        if (element.selected == 1) {
          this.survey_object = { "question_id": element.SurveyQuestionID, "answer": element.SurveyAnswerID, "userAnswer": "None", "type":this.question[this.current_question].type };
          console.log("mae bhi call ho raha");
          this.array_checkbox.push(this.survey_object);
          this.checbox_count++;
          console.log(this.array_checkbox);
          this.check_limit = true;
          this.checkbox_check = true;
          this.check = true;
         
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.ts